import { Box, Stack, Typography } from "@mui/material";
import EmptyStateImage from "public/images/empty_state_image.png";

interface Props {
  hideImage?: boolean;
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
}

export function EmptyState(props: Props) {
  return (
    <Stack
      direction={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      spacing={1}
      textAlign={"center"}
      maxWidth={"400px"}
    >
      {!props.hideImage ? (
        <Box>
          <Box
            component={"img"}
            src={EmptyStateImage.src}
            width={"76px"}
            height={"auto"}
            sx={{ filter: "grayscale(100%)", opacity: 0.5 }}
          />
        </Box>
      ) : null}

      {props?.title && (
        <Box>
          <Typography
            variant="subtitle1"
            fontWeight={"600"}
            lineHeight={1.1}
            color="text.primary"
          >
            {props.title}
          </Typography>
        </Box>
      )}

      {props?.description && (
        <Box>
          <Typography
            variant="body1"
            fontWeight={"400"}
            lineHeight={1.2}
            color="text.secondary"
          >
            {props.description}
          </Typography>
        </Box>
      )}
    </Stack>
  );
}
